import axios from 'axios';

import { responseEntityMapper, responseListMapper } from '@qwealth/qcore';
import { REACT_APP_QWEALTH_API } from '@qwealth/qdata';

import {
  ChecklistSubmission,
  ClientComplianceReview,
  ClientComplianceReviewQueryParams,
  ComplianceApprovalNote,
  ComplianceNote,
} from 'data/models/Compliance';

export const fetchClientsComplianceReview = async (params?: ClientComplianceReviewQueryParams): Promise<ClientComplianceReview[]> =>
  axios
    .get(`${REACT_APP_QWEALTH_API}/complianceChecklist/members`, { params })
    .then(response => responseListMapper<ClientComplianceReview>(response));

// export const updateComplianceClient = async (clientId: string): Promise<ClientComplianceReview> =>
//   axios.patch(`${REACT_APP_QWEALTH_API}/complianceChecklist/${clientId}`).then(response => responseEntityMapper<ClientComplianceReview>(response));

export const postComplianceChecklist = async (qid: string, checklistSubmission: ChecklistSubmission) =>
  axios
    .post(`${REACT_APP_QWEALTH_API}/complianceChecklist/${qid}`, checklistSubmission)
    .then(response => responseEntityMapper<ClientComplianceReview>(response));

export const postClientComplianceReviewAssignee = async (qid: string, assignee: string | null): Promise<string | null> =>
  axios
    .post(`${REACT_APP_QWEALTH_API}/complianceChecklist/${qid}`, { assignee })
    .then(response => responseEntityMapper<{ assignee: string }>(response))
    .then(data => data.assignee);

export const fetchComplianceAssignees = async (): Promise<string[]> =>
  axios.get(`${REACT_APP_QWEALTH_API}/complianceAssignees`).then(response => responseListMapper<string>(response));

export const fetchClientNotesHistory = async (qid: string): Promise<(ComplianceNote | ComplianceApprovalNote)[]> =>
  axios
    .get(`${REACT_APP_QWEALTH_API}/complianceNoteHistory/`, { params: { owners: qid } })
    .then(response => responseListMapper<ComplianceNote | ComplianceApprovalNote>(response));

export const postComplianceReReviewNote = async (note: ComplianceNote): Promise<ComplianceNote> =>
  axios.post(`${REACT_APP_QWEALTH_API}/complianceReReview/`, note).then(response => responseEntityMapper<ComplianceNote>(response));
